import { render } from "./FilterPlanos.vue?vue&type=template&id=0101a800&scoped=true"
import script from "./FilterPlanos.vue?vue&type=script&lang=js"
export * from "./FilterPlanos.vue?vue&type=script&lang=js"

import "./FilterPlanos.vue?vue&type=style&index=0&id=0101a800&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0101a800"]])

export default __exports__